import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Tooltip } from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { Enterprise } from '../type';
import { useState } from 'react';
import { formatDate } from '../utils/dateUtils';

interface EnterpriseTableProps {
  data: Enterprise[];
  onEnterpriseSelect: (enterprise: Enterprise) => void;
  onDelete: (enterpriseId: string) => void;
}

export const EnterpriseTable = ({
  data,
  onEnterpriseSelect,
  onDelete,
}: EnterpriseTableProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ flex: 2 }}>
      <TableContainer>
        <Table stickyHeader size="small">
                      <TableHead>
              <TableRow>
                <TableCell>기업 ID</TableCell>
                <TableCell>기업명</TableCell>
                <TableCell>로고</TableCell>
                <TableCell>생성일</TableCell>
                <TableCell>작업</TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {pagedData.map((row) => (
              <TableRow key={row.enterpriseId} hover style={{ cursor: 'pointer' }} onClick={() => onEnterpriseSelect(row)}>
                <TableCell>{row.enterpriseId}</TableCell>
                <TableCell>{row.enterpriseName}</TableCell>
                <TableCell>
                  {row.logoUrl && (
                    <img 
                      src={row.logoUrl} 
                      alt={row.enterpriseName}
                      style={{ width: 40, height: 40, objectFit: 'contain' }}
                    />
                  )}
                </TableCell>
                <TableCell>{formatDate(row.createdAt)}</TableCell>
                <TableCell onClick={e => e.stopPropagation()}>
                  <Tooltip title="수정">
                    <IconButton 
                      size="small" 
                      onClick={() => onEnterpriseSelect(row)}
                      sx={{ mr: 1 }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="삭제">
                    <IconButton 
                      size="small" 
                      onClick={() => onDelete(row.enterpriseId)}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={data.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
    </Box>
  );
}; 